import { EditForm } from "./edit-form";

export const Sweepstakes = {
  EditForm,
};
